const normalizeFieldMessages = (payload) => {
  if (!payload || typeof payload !== "object") return [];

  return ["email", "password"].flatMap((name) => {
    const raw = payload[name];
    if (!raw) return [];
    const messages = Array.isArray(raw) ? raw : [raw];
    return [{
      name,
      errors: messages.map((message) => {
        const text = String(message || "").trim();
        if (text.toLowerCase() === "this field is required.") {
          return name === "email" ? "Enter your email address." : "Enter your password.";
        }
        return text || `Enter a valid ${name}.`;
      }),
    }];
  });
};

export const loginNetworkFailure = () => ({
  status: 0,
  title: "We couldn't connect to the server",
  message: "Check your internet connection and try again. Your sign-in details were not submitted.",
  fieldErrors: [],
});

export const readLoginFailure = async (response) => {
  let payload = null;

  try {
    const raw = await response.text();
    payload = raw ? JSON.parse(raw) : null;
  } catch {
    payload = null;
  }

  const fieldErrors = normalizeFieldMessages(payload);
  const status = response.status;

  if (status === 401) {
    return {
      status,
      title: "We couldn't sign you in",
      message: "The email or password is incorrect. Check both fields and try again.",
      fieldErrors: [],
    };
  }

  if (status === 403) {
    return {
      status,
      title: "This account is not available",
      message: "Your account may be inactive. Contact the BackUp team if you believe this is a mistake.",
      fieldErrors: [],
    };
  }

  if (status === 429) {
    return {
      status,
      title: "Too many sign-in attempts",
      message: "Wait a few minutes before trying again.",
      fieldErrors: [],
    };
  }

  if (status >= 500) {
    return {
      status,
      title: "Sign-in is temporarily unavailable",
      message: "The server couldn't complete your request. Please try again in a moment.",
      fieldErrors: [],
    };
  }

  const detail = payload?.detail || payload?.error || payload?.message;
  return {
    status,
    title: fieldErrors.length ? "Check your sign-in details" : "We couldn't sign you in",
    message: fieldErrors.length
      ? "Correct the highlighted fields and try again."
      : String(detail || "Please check your details and try again."),
    fieldErrors,
  };
};

export const normalizeLoginError = (error) => {
  if (error && typeof error === "object" && error.title && error.message) return error;

  const text = typeof error === "string" ? error : error?.message;
  const lower = String(text || "").toLowerCase();

  if (lower.includes("invalid") || lower.includes("credentials") || lower.includes("active account")) {
    return {
      status: 401,
      title: "We couldn't sign you in",
      message: "The email or password is incorrect. Check both fields and try again.",
      fieldErrors: [],
    };
  }

  return loginNetworkFailure();
};
